module.exports = __webpack_public_path__ + "img/apple-touch-icon.3cea4496.png";